import { render, staticRenderFns } from "./TreeviewFilter.vue?vue&type=template&id=6fb833d4&"
import script from "./TreeviewFilter.vue?vue&type=script&lang=js&"
export * from "./TreeviewFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTreeview } from 'vuetify/lib'
installComponents(component, {VTreeview})
